var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'bizcomp-private-assets bizcomp ' + _vm.className},[_c('comp-title',{attrs:{"title":_vm.title}}),_c('div',{staticClass:"private-con"},[_c('asset-fund',{ref:"assetFund",attrs:{"fund-info":_vm.privateInfo,"is-risk":0},on:{"fund-continue":_vm.fundCon}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }